/**
 * scripts.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.listings = {
    seteventfilterdate: function(form){
        var year = $(form).find('[name=year_select]').val();
        var minmonth = $(form).find('[name=month_select]').val();
        var maxmonth = $(form).find('[name=month_select]').val();

        if(year == 'all' && minmonth!="all")
        {
            year = new Date().getFullYear();
        }


        if(minmonth == 'all')
        {
            minmonth = '01';
        }
        if(maxmonth == 'all')
        {
            maxmonth = '12';
        }

        var maxlastday = new Date(year, maxmonth, 0).getDate()

        var minddate = year + '-' + minmonth + '-' + '01' +' 00:00:00';
        var maxddate = year + '-' + maxmonth + '-' + maxlastday +' 23:59:00';

        if(year != 'all' && minmonth!="all")
        {
           $(form).find('[name=field_events_date_value]').val(minddate);
           $(form).find('[name=field_events_end_date_value]').val(maxddate);
        }
        else
        {
            $(form).find('[name=field_events_date_value]').val("");
            $(form).find('[name=field_events_end_date_value]').val("");
        }

    },

    attach: function (context, settings) {

      once('listing', '.views-exposed-form', context).forEach(
        function (element) {
            var formid = $(element).data('drupal-selector');

              $(element).find('.form-select').change(function(){

                if(formid=='views-exposed-form-events-listing-page-1' || formid=='views-exposed-form-events-listing-page-2' )
                {
                    Drupal.behaviors.listings.seteventfilterdate(element);
                }

                if(formid!='views-exposed-form-document-listing-governance-documents' && formid != 'views-exposed-form-media-view-page-1' && formid != 'views-exposed-form-news-page-1')
                {
                    $(element).find('.js-form-submit').click();
                }

              })
        }
      );


    }
  };

})(jQuery, Drupal, drupalSettings);
